export default __webpack_public_path__ + "static/top-05f254b45dceae6bb8620cc643adea1e.gif";